<template>
  <div id="wrap">
    <!-- title -->
    <div class="title">供应链解决方案</div>
    <div
      class="text"
    >从终端回收到二手销售，我们拥有苏宁、支付宝、闲鱼等回收合作伙伴，天机汇、苏宁二手等B端与C端销售平台，为您提供一整套的买卖接口，让买卖在同城帮的生态链内一站式完成，解决压货、无货可卖等烦恼。</div>

    <!-- 内容区 -->
    <ul class="content">
      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p4.ssl.qhimg.com/t01f0dd0d59c00975e0.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">行情报价解决方案</div>
          <!-- text -->
          <div class="content-bottom-text">通过大数据分析，为您提供及时的行情分析，帮助您更了解市场动向。</div>
        </div>
      </li>

      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p2.ssl.qhimg.com/t017c2cd8e95ab6f101.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">大宗拍卖解决方案</div>
          <!-- text -->
          <div class="content-bottom-text">同城帮拥有专业的B2B平台天机汇，使用手机APP就能为您解决竞拍问题。</div>
        </div>
      </li>

      <li>
        <div class="content-top">
          <!-- 图片 -->
          <img src="https://p2.ssl.qhimg.com/t01091032bd54530546.png" alt />
        </div>
        <div class="content-bottom">
          <!-- title -->
          <div class="content-bottom-title">批量交接解决方案</div>
          <!-- text -->
          <div class="content-bottom-text">批量交易无非复杂操作，同城帮天机汇APP让您一站式解决，并为您提供专属客服，全程进行问题解答与服务支持。</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#wrap {
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 50px;
  }
  //   展示区
  .content {
    margin-bottom: 50px;
    li {
      height: 200px;
      display: flex;

      margin-bottom: 44px;
      .content-top {
        margin-right: 25px;
        img {
          height: 200px;
          width: 300px;
        }
      }
      .content-bottom {
        // padding: 25px 30px 35px 30px;
        padding: 15px 0 10px 0;
        box-sizing: border-box;
        .content-bottom-title {
          font-size: 20px;
          font-weight: 600;
          color: #000000;
          margin-bottom: 20px;
        }
        .content-bottom-text {
          font-size: 16px;
          color: #666666;
          line-height: 26px;
        }
      }
    }
  }
}
</style>
